import React from "react";
import { Route, Redirect } from "react-router-dom";
import Auth from "./Auth";

class TeacherRoute extends React.Component {
  state = {
    auth: false,
    loading: true,
    error: "",
  };

  async componentDidMount() {
    const response = await Auth.tokenCheck("teacher");
    if (response.authenticated) {
      this.setState({ auth: true });
    } else {
      Auth.logout();
    }

    this.setState({ error: response.error });
    this.setState({ loading: false });
  }

  async componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      const response = await Auth.tokenCheck("teacher");
      if (response.authenticated) {
        this.setState({ auth: true });
      } else {
        Auth.logout();
        this.setState({ auth: false });
      }
      this.setState({ error: response.error });
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, auth } = this.state;
    if (!loading && !auth) {
      let params = (new URL(document.location)).searchParams;
      const request_view_id = params.get("request_view_id");
      const teacher_id = params.get("teacher_id");
      localStorage.setItem("request_view_id", request_view_id);
      if(teacher_id) {
        return (
          <Redirect
            to={{
              pathname: "/login",
              search: `?vtid=${teacher_id}`,
            }}
          />
        );
      }
      else if (this.props.path === "/") {
        return (
          <Redirect
            to={{
              pathname: "/login",
            }}
          />
        );
      } else {
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: {
                error: this.state.error,
              },
            }}
          />
        );
      }
    } else {
      return (
        !loading &&
        (this.props.component ? (
          <Route
            exact={this.props.exact}
            path={this.props.path}
            component={this.props.component}
          />
        ) : (
          <Route
            exact={this.props.exact}
            path={this.props.path}
            render={this.props.render}
          />
        ))
      );
    }
  }
}

export default TeacherRoute;
